module.exports = __webpack_public_path__ + "static/highfive-51a14d5853039cec1831b2c604b6099f.svg";